import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "className", "style", "position", "href", "target", "edit", "ratio"];
import { withTheme } from '@emotion/react';
import React, { useContext } from 'react';
import ImageSubstitution from '../ImageSubstitution.js';
import linkify from '../LinkHandlers.js';
import { useLightbox, SectionLightboxContext } from '../Lightbox/index.js';
import * as css from './index.module.css';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var sizes = {
  '1:2': css.ratioA,
  '9:16': css.ratioB,
  '2:3': css.ratioC,
  '3:4': css.ratioD,
  '1:1': css.ratioE,
  '4:3': css.ratioF,
  '3:2': css.ratioG,
  '16:9': css.ratioH,
  '2:1': css.ratioI
}; // Emotion 10 has hooks

var Img = withTheme(function Img(_ref) {
  var theme = _ref.theme,
      src = _ref.src,
      srcSet = _ref.srcSet,
      sizes = _ref.sizes,
      alt = _ref.alt,
      style = _ref.style,
      svgColor = _ref.svgColor,
      lightbox = _ref.lightbox,
      description = _ref.description,
      edit = _ref.edit;
  var sectionLightbox = useContext(SectionLightboxContext);
  var hasLightbox = typeof lightbox !== 'undefined' ? lightbox : sectionLightbox || false;
  var onClick = useLightbox(hasLightbox, {
    src: src,
    srcSet: srcSet,
    description: description || alt || ''
  }, edit);
  var themeColor = theme.variables['color-variable-btn-1'];
  return ___EmotionJSX("img", {
    className: "image " + css.image + " " + (hasLightbox ? css.active : ''),
    src: ImageSubstitution(src, svgColor || themeColor),
    sizes: sizes,
    srcSet: ImageSubstitution(srcSet),
    onClick: onClick,
    alt: alt,
    style: style
  });
});

function coord(x) {
  if (typeof x === 'number') {
    x += 'px';
  }

  if (x[0] === '-') {
    x = x.substring(1);
  } else {
    x = '-' + x;
  }

  return x;
}

export function Image(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      style = _ref2.style,
      position = _ref2.position,
      href = _ref2.href,
      target = _ref2.target,
      edit = _ref2.edit,
      _ref2$ratio = _ref2.ratio,
      ratio = _ref2$ratio === void 0 ? null : _ref2$ratio,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

  var objectPosition;

  if (position && (position.x || position.y)) {
    var _position$x = position.x,
        x = _position$x === void 0 ? 0 : _position$x,
        _position$y = position.y,
        y = _position$y === void 0 ? 0 : _position$y;
    objectPosition = coord(x) + " " + coord(y);
  }

  var isRaw = process.env.ENV_RAW || !edit;

  var comp = ___EmotionJSX(Img, _extends({
    style: {
      objectPosition: objectPosition
    },
    edit: !isRaw
  }, rest));

  if (isRaw) {
    var Anchor = href ? linkify({
      href: href,
      target: target
    }) : null;
    return ___EmotionJSX("div", {
      className: "image-box " + className + " " + css.image + " " + (ratio ? css.intrinsic : '') + " " + (ratio ? sizes[ratio] : ''),
      style: style
    }, href ? ___EmotionJSX(Anchor.Component, _extends({
      className: ratio ? css.inner : undefined
    }, Anchor.props), comp) : ratio ? ___EmotionJSX("div", {
      className: css.inner
    }, comp) : comp);
  }

  return ___EmotionJSX("div", _extends({
    style: Object.assign({}, style, {
      overflow: 'visible'
    }),
    className: "image-box position-relative " + className + " " + css.image
  }, rest.uiEvents), ___EmotionJSX("div", {
    className: className + " " + css.image + " " + (ratio ? css.intrinsic : '') + " " + (ratio ? sizes[ratio] : '')
  }, ratio ? ___EmotionJSX("div", {
    className: css.inner
  }, comp) : comp), children);
}